import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as CookieConsent from "vanilla-cookieconsent";
import { createPluginConfig } from "./cookie-consent-config";

/**
 * Component that syncs cookie consent language with i18n language changes
 */
export const CookieConsentLanguageSync = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      // Reset and reinitialize cookie consent with new language
      CookieConsent.reset(false);
      const newConfig = createPluginConfig(lng);
      CookieConsent.run(newConfig);
    };

    // Listen to language changes
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return null;
};
